import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    setupViewPrinting: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 0px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    setupViewPrintingContainer: {
      background: 'white',
      color: '#2A2A2A',
      minWidth: '100%',
      borderRadius: '8px',
      height: '879px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        height: '1700px'
      },
      [theme.breakpoints.only('lg')]: {
        height: '830px'
      }
    },
    setupViewPrintingText: {
      padding: '0 140px',
      alignItems: 'center',
      justifyContent: 'center',
      borderRight: '1px solid #D8D8D8',
      background: 'transparent',
      display: 'grid',
      [theme.breakpoints.down('lg')]: {
        padding: '72px 140px 0px 140px',
        height: '135px'
      },
      [theme.breakpoints.only('lg')]: {
        maxWidth: '60%',
        height: '100%',
        padding: '72px 30px 0px 30px',
        borderRight: '1px solid #D8D8D8'
      }
    },
    setupPrintingContentBox: {
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        display: 'grid',
        height: '50%'
      },
      [theme.breakpoints.only('lg')]: {
        display: 'flex',
        height: '100%'
      }
    },
    backToSetupLandscape: {
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      },
      [theme.breakpoints.only('lg')]: {
        display: 'flex'
      }
    },
    backToSetupPortrait: {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        display: 'flex'
      },
      [theme.breakpoints.only('lg')]: {
        display: 'none'
      }
    },
    setupViewPrintingHeaders: {
      fontSize: '100px',
      fontWeight: 600,
      fontFamily: 'Poppins, sans-serif',
      lineHeight: 1.1,
      margin: '0px 0px 48px 0px',
      [theme.breakpoints.down('lg')]: {
        fontSize: '64px',
        margin: '0px 0px 24px 0px'
      },
      [theme.breakpoints.only('lg')]: {
        fontSize: '100px'
      }
    },
    setupPrintingSubHeader: {
      margin: '0px 0px 48px 0px',
      flex: 'none',
      background: 'transparent',
      textAlign: 'start',
      [theme.breakpoints.down('lg')]: {
        margin: '0px 0px 8px 0px',
        textAlign: 'center'
      },
      [theme.breakpoints.only('lg')]: {
        textAlign: 'start',
        margin: '0px 0px 48px 0px'
      }
    },
    SetupPrintingImageContainer: {
      [theme.breakpoints.only('lg')]: {
        maxWidth: '40%'
      },
      '& > *': {
        [theme.breakpoints.only('lg')]: {
          padding: '0px 5px 0px 5px'
        }
      }
    },
    setupViewPrintingCompleteBox: {
      flex: 'none',
      width: '610px',
      background: 'transparent',
      margin: '0px 0px 56px 0px',
      [theme.breakpoints.only('lg')]: {
        paddingLeft: '45px'
      }
    }
  })
);
